import React, { ReactElement, useCallback, useState } from 'react';
import { PromptTypes } from '..';
import { PromptContextType, PromptOptions } from './types';

/**
 * React context for managing notifications
 */
export const PromptContext = React.createContext<PromptContextType>({
  visible: false,
  options: { title: '', body: null, type: PromptTypes.INFO },
  showPrompt: () => {
    throw new Error('No Provider');
  },
});

/**
 * Context provider for Notifications
 * @param {ReactElement} children components that uses notification
 */
export default function PromptProvider({ children }: { children: ReactElement }): ReactElement {
  const [options, setOptions] = useState<PromptOptions>({
    title: '',
    body: null,
    type: PromptTypes.INFO,
  });
  const [visible, setVisible] = useState<boolean>(false);

  const showPrompt = useCallback((promptOptions: PromptOptions): Promise<boolean> => {
    return new Promise((resolve) => {
      setOptions({
        ...promptOptions,
        onConfirm: () => {
          resolve(true);
          setVisible(false);
        },
        onCancel: () => {
          resolve(false);
          setVisible(false);
        },
      });
      setVisible(true);
    });
  }, []);

  const contextValue = {
    showPrompt,
    visible,
    options,
  };
  return <PromptContext.Provider value={contextValue}>{children}</PromptContext.Provider>;
}
